import { render, staticRenderFns } from "./NationalGlobalComparison.vue?vue&type=template&id=1f99b9b4&scoped=true&"
import script from "./NationalGlobalComparison.vue?vue&type=script&lang=ts&"
export * from "./NationalGlobalComparison.vue?vue&type=script&lang=ts&"
import style0 from "./NationalGlobalComparison.vue?vue&type=style&index=0&id=1f99b9b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f99b9b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol,VImg,VProgressCircular,VRow})
